module.exports = "/_next/static/images/uz-2627db26ee40a04deddeecbdaa016aa0.svg";